import { CenterFeedPlacement, TermPageType } from '@/types/models'
import { ScoringData } from '@/types/models'
import { isNonEmptyArray } from '@/utils/checks'
import { isPPV } from '@/domain/center'
import { PrimaryFocus } from '@/domain/primaryFocus/constant'
import { shouldUsePPVForLocalCentersInFeed } from './shouldUsePPVForLocalCentersInFeed'
const DEFAULT_LOCAL_BLOCK_COUNT = 3

const termPageTypeValues: string[] = Object.entries(TermPageType).flat()

export const createLocalCenters = ({
  organicCenters,
  scoringData,
  localBlockCount
}: {
  organicCenters: CenterFeedPlacement[]
  scoringData: ScoringData
  localBlockCount?: number
}) => {
  const { title, pageType, primaryFocus } = scoringData

  if (termPageTypeValues.includes(pageType)) {
    return organicCenters
      .filter((center) =>
        shouldUsePPVForLocalCentersInFeed({
          primaryFocus: primaryFocus as PrimaryFocus,
          center
        })
      )
      .splice(0, localBlockCount)
  }

  const localCenters = organicCenters
    .filter(
      (center) =>
        center.locations.includes(title) &&
        shouldUsePPVForLocalCentersInFeed({
          primaryFocus: primaryFocus as PrimaryFocus,
          center
        })
    )
    .slice(0, localBlockCount)

  if (!isNonEmptyArray(localCenters)) {
    return organicCenters.slice(0, DEFAULT_LOCAL_BLOCK_COUNT)
  }

  return localCenters
}
